import { render, staticRenderFns } from "./rightVocView.vue?vue&type=template&id=4c38bf3c&scoped=true&"
import script from "./rightVocView.vue?vue&type=script&lang=js&"
export * from "./rightVocView.vue?vue&type=script&lang=js&"
import style0 from "./rightVocView.vue?vue&type=style&index=0&id=4c38bf3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c38bf3c",
  null
  
)

export default component.exports